"use client";

import HeaderBackground from "@/components/ui/header-background";
import Breadcrumbs from "@/components/entities/breadcrumbs";
import TwoColumnsBlock from "@/components/ui/two-columns-block";
import video from "../../../../../../public/images/header-backgrund-test.gif";
import { useTranslations } from "next-intl";
import { useTechnologyData } from "../../hooks/useTechnologyData";
import { Container } from "@/components/ui/container";
import S from "./index.module.scss";

const DetailTechnologyHeader = () => {
  const t = useTranslations();
  const { detailTechnology, isLoading } = useTechnologyData();

  if (!detailTechnology || isLoading) return null;

  const breadcrumbs = [
    { title: t("home"), url: "/" },
    { title: t("technology"), url: "/technologies" },
  ];

  return (
    <>
      <HeaderBackground type="image" src={video} />
      <Container>
        <div className={S.headerWrapper}>
          <Breadcrumbs breadcrumbs={breadcrumbs} />
          <h1 className={S.title}>{detailTechnology.technology?.title}</h1>
          <TwoColumnsBlock
            title={detailTechnology.technology?.subtitle}
            subtitle={detailTechnology.technology?.description}
          />
        </div>
      </Container>
    </>
  );
};

export default DetailTechnologyHeader;
